import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withMemo as _withMemo, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3" }

import StatsButtonMenu from "@/components/Menus/StatsButtonMenu.vue";
import { useMapStore } from "@/store/useMapStore";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatsButtonMenuContainer',
  setup(__props) {

const mapStore = useMapStore();

const countriesVisitedStat = computed(() => {
  return mapStore.countriesVisitedStats;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withMemo([countriesVisitedStat.value.onu], () => _createVNode(StatsButtonMenu, {
      text1: countriesVisitedStat.value.onu,
      text2: "Countries",
      class: "mx-auto"
    }, null, 8, ["text1"]), _cache, 0),
    _withMemo([countriesVisitedStat.value.area], () => _createVNode(StatsButtonMenu, {
      text1: countriesVisitedStat.value.area,
      text2: "Of the world",
      class: "mx-auto"
    }, null, 8, ["text1"]), _cache, 1),
    _withMemo([countriesVisitedStat.value.continent], () => _createVNode(StatsButtonMenu, {
      text1: countriesVisitedStat.value.continent,
      text2: "Continent",
      class: "mx-auto"
    }, null, 8, ["text1"]), _cache, 2)
  ]))
}
}

})